<template>
  <v-app-bar
    v-if="userIsAuthenticated"
    :extension-height="
      $vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs' ? '130%' : 'auto'
    "
    color="primary"
    dark
    app
    flat
  >
    <template v-slot:extension v-if="showFilter">
      <v-layout row>
        <v-flex xs12 sm12 md12 style="margin-top: -4px">
          <user-filter
            ref="userFilter"
            :custom="{
              'background-color': '#1976d2',
              'border-color': '#1976d2!important',
              padding: '7px',
              'box-shadow': '2px 3px 4px #404040'
            }"
          ></user-filter>
        </v-flex>
      </v-layout>
    </template>

    <v-btn v-if="subPage" @click="$router.go(-1)" icon>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-app-bar-nav-icon v-else @click.stop="sideNavUpdate()">
      <v-icon>dehaze</v-icon>
    </v-app-bar-nav-icon>

    <v-toolbar-title v-if="subPage">{{ title }}</v-toolbar-title>
    <v-toolbar-title v-else>
      <span to="/" tag="span">{{ title }}</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <v-btn @click="refresh" :disabled="reloading" icon text>
      <v-icon medium>refresh</v-icon>
    </v-btn>

    <v-btn v-if="canSee('filter')" @click="showFilter = !showFilter" icon text>
      <v-badge v-if="filtersApplied" color="red" small overlap>
        <template v-slot:badge>
          <span small></span>
        </template>
        <v-icon v-if="showFilter" medium>filter_list</v-icon>
        <v-icon v-else medium>filter_list</v-icon>
      </v-badge>

      <v-icon v-else-if="!filtersApplied && showFilter" medium>filter_list</v-icon>
      <v-icon v-else-if="!filtersApplied && !showFilter" medium>filter_list</v-icon>
    </v-btn>

    <v-menu
      :nudge-bottom="14"
      offset-y
      origin="center center"
      class="elelvation-1"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" icon text style="margin-right: 1px">
          <v-badge :color="notificationsCount > '' ? 'red' : ''" overlap>
            <span slot="badge">{{ notificationsCount }}</span>
            <v-icon medium>notifications</v-icon>
          </v-badge>
        </v-btn>
      </template>
      <notifications></notifications>
    </v-menu>
  </v-app-bar>
</template>

<script>
import notifications from "@/components/toolbar/notifications";
import canSee from "@/utilities/canSee";
export default {
  components: {
    notifications
  },

  props: ["router"],

  data() {
    return {
      reloading: false,
      showFilter: false,
      subPage: false,
      title: "Home",
      unsub: () => {}
    };
  },

  computed: {
    filtersApplied() {
      console.log("Filter Applied", this.$store.getters.selectedTags);

      return this.$store.getters.selectedTags.length > 0;
    },

    notificationsCount() {
      console.log("Count", this.$store.getters.notificationsCount);

      var nCount = this.$store.getters.notificationsCount;

      if (nCount == 0) {
        return "";
      } else {
        return nCount;
      }
    },

    userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    groups() {
      const groups = [...this.$store.getters.groups];
      groups.push({ name: "All", id: "all", selected: true });

      return groups;
    },
    group: {
      set(v) {
        this.$store.commit("setGroup", v);
      },
      get(e) {
        return this.$store.getters.group;
      }
    }
  },
  watch: {
    $route(to, from) {
      // react to route changes...

      this.subPage = to.meta.subPage;
      this.title = to.name;

      this.showFilter = false;
    }
  },
  beforeDestroy() {
    this.unsub();
  },
  mounted() {
    // console.log(JSON.stringify(this.$router.currentRoute)

    this.subPage = this.$router.currentRoute.meta.subPage;
    this.title = this.$router.currentRoute.name;
  },

  created() {
    const self = this;

    /*
    self.unsub = self.$store.subscribe((mutation, state) => {
      if (mutation.type === 'notificationUpdate') {



        var nseen = 0;
        state.getters.notifications.forEach((n) => {
          if (!n.seen) nseen++;
        });

        if (nseen == 0) nseen = "";

        self.notificationCount.set(nseen)



      }
    });

*/
  },
  methods: {
    refresh() {
      const self = this;
      self.reloading = true;

      var currentRoute = self.$route.fullPath;
      if (currentRoute == "/load") {
        self.$router.replace(
          "/",
          function() {
            self.reloading = false;
          },
          function() {
            self.reloading = false;
          }
        );
      } else {
        self.$router.replace(
          "/load",
          function() {
            self.$nextTick(() => {
              self.$router.replace(currentRoute);
              self.reloading = false;
            });
          },
          function() {
            self.reloading = false;
          }
        );
      }
    },
    canSee(what, role, options) {
      return canSee(this, what, role, options);
    },

    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },

    sideNavUpdate() {
      this.$emit("sideNavUpdate");
    },

    onLogout() {
      this.$emit("logout");
    },
    onchange() {}
  }
};
</script>

<style scoped></style>
